<template>
  <div class="content main-container">
    <div class="top clearfix">
      <div class="info">
        <p class="blod">说明：为加快介绍费的发放进度，我们安排每月结算两次:</p>
        <p>1）保单冷静期截止日在当月12日或之前，介绍费将于下月10日安排结算；</p>
        <p>2）保单冷静期截止日在当月12日之后，介绍费将于下月25日安排结算；</p>
        <p class="blod">备注： 因为香港部分银行转账有周期，到账延误两个工作日属于正常情况；若发放的日期是香港公众假期或休息日，介绍费发放将顺延至下一个工作日进行安排;</p>
        <p style="padding-top:4px;">举例：1.保单冷静期截止日为8月12日，则9月10日安排结算</p>
        <p class="p2">2.保单冷静期截止日为8月30日，则9月25日安排结算</p>
      </div>
    </div>
    <Tabs v-model="sureStatus" :animated="false" @on-click="resetSearch">
      <TabPane label="待确认" name="0"></TabPane>
      <TabPane label="已确认" name="1"></TabPane>
    </Tabs>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.commissionPeriod"
          @on-change="searchParams.commissionPeriod = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">结算类型</span>
        <Select v-model="searchParams.settlementType" filterable clearable>
          <Option value="1">首期</Option>
          <Option value="2">续期</Option>
          <Option value="3">周边服务</Option>
        </Select>
      </div>
      <div class="input-item" v-if="sureStatus == 1">
        <span class="label">状态</span>
        <Select v-model="searchParams.withdrawStatus" clearable>
          <Option value="0">待打款</Option>
          <Option value="1">已打款</Option>
        </Select>
      </div>
      <div class="input-item" v-if="sureStatus == 1">
        <span class="label">打款时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.paymentTime"
          @on-change="searchParams.paymentTime = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" icon="ios-search" class="ico-btn" @click="searchAjax()">查询</Button>
      </div>
    </div>
    <div class="tools-box" v-if="sureStatus == '0' && tableData.length">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll">全部账单</Checkbox>
      </div>
      <div class="right-box">
        <span class="text"
          >已选择<span>{{ isAll ? total : selectArr.length }}</span
          >项，共<span>{{ total }}</span
          >项</span
        >
        <Button type="primary" @click="billConfirm">批量确认</Button>
      </div>
    </div>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
        <template slot-scope="{ row }" slot="currencyType">
          <lzDicTxt dicType="CURRENCY_TYPE" :dicCode="row.currencyType"></lzDicTxt>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span @click="exportList(row)" class="table-btn"> 导出明细 </span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
    <!-- 确认账单 -->
    <bill-confirm ref="billConfirm" @reload="reload" />
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import billConfirm from './components/billConfirm';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, common, config],
  components: {
    billConfirm,
    lzDicTxt
  },
  data() {
    return {
      sureStatus: '0',
      searchParams: {
        paymentTime: [],
        commissionPeriod: []
      },
      isAll: false, //全部产品
      selectArr: [] //表格选择的数据
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.initListParams('/buz/settlementTotal/read/list');
  },
  activated() {
    this.getList();
  },
  methods: {
    reload() {
      this.selectArr = [];
      this.isAll = false;
      this.getList();
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 批量确认
    billConfirm() {
      if (this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一项数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      const ids = this.selectArr.map(item => item.id);
      if (this.isAll) {
        params.isAll = 1;
      } else {
        params.isAll = 0;
        params.totalIds = ids;
      }
      this.$refs.billConfirm.open(params);
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    // 设置参数
    setListParams(params) {
      // 结算周期
      if (params.commissionPeriod && params.commissionPeriod[0]) {
        params.commissionPeriodStart = params.commissionPeriod[0];
        params.commissionPeriodEnd = params.commissionPeriod[1];
      }
      delete params.commissionPeriod;

      // 打款时间
      if (params.paymentTime && params.paymentTime[0]) {
        params.paymentTimeStart = params.paymentTime[0];
        params.paymentTimeEnd = params.paymentTime[1];
      }
      delete params.paymentTime;
      params.sureStatus = this.sureStatus;
      this.getColumns();
    },
    // 重置查询
    resetSearch() {
      this.selectArr = [];
      this.isAll = false;
      this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
      this.searchAjax();
    },
    async exportList(row) {
      this.$units.downloadFun({
        url: '/buz/settlementTotal/settleDetail/export',
        type: 'POST',
        params: {
          id: row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  color: #6e574a;
  line-height: 1.6;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  font-size: 13px;
  .p2 {
    padding-left: 3em;
  }
  .blod {
    font-weight: bold;
  }
}
.content {
  .top {
    padding-bottom: 15px;
  }
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
</style>
